$(document).ready(function() {
    $(".accordion-head").click(function() {
      $(this).next('.accordion-body').slideToggle(300);
      $(this).toggleClass('acc_open');
    });
  });

// if (window.matchMedia("(max-width: 767px)").matches) {
// $('.feature-slideshow').slick({
//    slidesToShow: 1,
//    infinite:false,
//    slidesToScroll: 1,
//    autoplay: false,
//    dots: true,
//    arrows: false,
//   });
// }


function initializeSlider() {
  if (window.matchMedia("(max-width: 768px)").matches) {
    if (!$('.js-feature-slideshow').hasClass('flickity-enabled')) {
      $('.js-feature-slideshow').flickity({
        imagesLoaded: true,
        pageDots: true,
        watchCSS: true,
        prevNextButtons: false
      });
    }
  } else {
    if ($('.js-feature-slideshow').hasClass('flickity-enabled')) {
      $('.js-feature-slideshow').flickity('destroy');
    }
  }
}

// Debounce function to limit the rate of function calls
function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

// Initialize slider on page load
$(document).ready(function() {
  initializeSlider();

  // Reinitialize slider on window resize with debounce
  $(window).resize(debounce(function() {
    initializeSlider();
  }, 100));
});
// $(".lightbox").fancybox({
//   backFocus: false,
//   trapFocus: false,
// });

/* ---------------------------------------------------------------------------
   Smooth scroll for in-page "Link anchor id" jump links (e.g. #buyers-guide,
   #faqs). Scoped to Design Packs / EB anchor targets (.dsgn-pck__anchor-id)
   only, so it never interferes with tabs, accordions or other # links.
   Offsets by the sticky header height so the target isn't hidden beneath it.
   --------------------------------------------------------------------------- */
(function () {
  var GAP = 24; // breathing space above the target

  function stickyHeaderHeight() {
    // The sticky nav is a Headhesive clone that is display:none until the page
    // scrolls, so it measures 0 at click time. Prefer the height the theme
    // records on it once it has stuck (readable via getComputedStyle even while
    // hidden); before that, fall back to the in-flow nav height.
    var clone = document.querySelector('.sticky_nav');
    if (clone) {
      var recorded = parseInt(getComputedStyle(clone).getPropertyValue('--sticky-header-height'), 10);
      if (recorded) return recorded;
    }
    var nav = document.querySelector('.main-nav__wrapper:not(.sticky_nav)') ||
              document.querySelector('.main-nav__wrapper');
    var h = nav ? nav.getBoundingClientRect().height : 0;
    return h ? Math.round(h) : 100;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="#"]');
    if (!link) return;

    // Same-page links only (ignore links to other pages that carry a hash).
    if (link.hostname !== window.location.hostname || link.pathname !== window.location.pathname) return;

    var hash = link.hash;
    if (!hash || hash === '#') return;

    var target;
    try { target = document.getElementById(decodeURIComponent(hash.slice(1))); }
    catch (err) { return; }

    // Only handle "Link anchor id" targets; leave every other # link alone.
    if (!target || !target.classList.contains('dsgn-pck__anchor-id')) return;

    e.preventDefault();

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight() - GAP;

    window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });

    // Keep the URL shareable without triggering a second hard jump.
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', hash);
    }
  });
})();

